// Faithful port of eb-ui `packages/eds/eds-share-box/src/WhatsappShare.jsx`.
// NB WhatsApp has NO aff code (only utm params) — eb-ui source verbatim.
import React from 'react';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoWhatsapp } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '../../i18n/gettext';
import { openUrl } from './utils';
import type { BaseShareProps, UtmOptions } from './types';

const _getEventUrl = (eventUrl: string, utmOptions: UtmOptions | undefined) =>
    formatUrl(eventUrl, {
        ...utmOptions,
    });

export type WhatsappShareProps = BaseShareProps;

export default class WhatsappShare extends React.Component<WhatsappShareProps> {
    _handleButtonClick() {
        const { eventName, eventUrl, onClick, utmOptions } = this.props;
        const text = gettext('Check out "%(eventName)s" %(eventUrl)s', {
            eventName,
            eventUrl: _getEventUrl(eventUrl, utmOptions),
        });
        const url = formatUrl('whatsapp://send', { text });

        if (onClick) {
            onClick();
        }

        openUrl(url);
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="whatsapp-share-box-container"
            >
                <IconButton
                    onClick={this._handleButtonClick.bind(this)}
                    iconType={<LogoWhatsapp />}
                    title={gettext('Share on Whatsapp')}
                />
            </span>
        );
    }
}
